import React, { useContext, useState } from 'react';
import { Store } from '../../store';

import { toggleParams, searchAction } from "../../actions";
import Form from 'react-bootstrap/Form';
import FormControl from 'react-bootstrap/FormControl';
import Button from 'react-bootstrap/Button';
import InputGroup from 'react-bootstrap/InputGroup';
import { MdClose } from "react-icons/md";

import './ProductTaxoIsin.scss';

export interface ProductTaxoIsinProps {
}

export function ProductTaxoIsin({}: ProductTaxoIsinProps) {
  
  const { state, dispatch }: any = useContext(Store);

  const handleCheckboxChange = (event: any) => {
    const target = event.target;
    const id = target.id;
    const value = target.type === "checkbox" ? target.checked : target.value;
    toggleParams({ [id]: value }, state, dispatch)
  }
  
  const [isin, setIsin] = useState("");
  const [enabled, setEnabled] = useState(false);

  const handleIsinChange = (event: any) => {
    const target = event.target;
    const value = target.value === "" ? "" : target.value;
    if (value && value.length == 12) {
      setEnabled(true);
    } else {
      setEnabled(false);
    }
    setIsin(value);
  };

  const onRemoveIsin = () => {
    setIsin("");
    setEnabled(false);
    searchAction("", dispatch);
  };

  function onSubmitIsin() {
    searchAction(isin, dispatch);
  }


  return (
    <div className="mt-2">
      <Form.Group id="formGridCheckbox" className="mb-0">
        <ul className="list-inline d-flex flex-column flex-sm-row justify-content-sm-between w-100 mb-0">
          <li className="list-inline-item d-sm-flex align-items-sm-center">
            <Form.Check
              custom
              type="checkbox"
              label="Éligible PEA"
              id="french_pea"
              onChange={handleCheckboxChange}
            />
          </li>
          <li className="list-inline-item d-sm-flex align-items-sm-center">
            <InputGroup className="d-flex align-items-center mb-0">
              <div className="container-form-control">
                <FormControl
                  placeholder="Code ISIN"
                  aria-label=""
                  aria-describedby="isin"
                  className="pr-4"
                  id="isin"
                  value={isin}
                  onChange={(e: any) => handleIsinChange(e)}
                  required
                />
                {isin && (
                  <MdClose
                    size={20}
                    className="remove-input-content"
                    onClick={() => onRemoveIsin()}
                  ></MdClose>
                )}
                <InputGroup.Append>
                  <Button
                    variant="primary"
                    onClick={(e: any) => onSubmitIsin(e)}
                    disabled={!enabled}
                  >
                    ok
                  </Button>
                </InputGroup.Append>
              </div>
            </InputGroup>
          </li>
        </ul>
      </Form.Group>
    </div>
  );
}
